var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "347px",
    height: "240px",
    viewBox: "0 0 347 240",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.186384332 0.072741573 69.8796795 0.072741573 69.8796795 25.7209528 0.186384332 25.7209528"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP-(Elvis)-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "support-3--copy-2",
    transform: "translate(-25.000000, -177.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(25.000000, 178.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(0.000000, 69.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.3933437,165 C75.6404066,163.263438 73.8966396,162.140981 71.9504292,162.140981 L71.0589166,162.170183 L70.9182902,161.467053 C70.1307825,157.538311 66.5538921,154.686946 62.4133243,154.686946 C58.1415053,154.686946 54.5446928,157.644347 53.861483,161.719386 L53.6974189,162.698949 C53.2403832,162.624666 51.1895819,161.467053 48.8522544,162.735239 L48,161.263485 C49.3078253,160.553833 50.8535435,160.295263 52.333929,160.551282 C53.5028858,156.124962 57.6012656,153 62.4133243,153 C67.1477456,153 71.2683913,156.103981 72.4701608,160.473881 C74.9070987,160.658736 77.0428617,162.138145 78,164.34762 L76.3933437,165 Z",
    id: "Fill-1",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7448299,167 L32,166.528014 C34.2183227,157.822046 45.6224655,156.229913 50,164.059694 L48.4373526,164.987735 C44.8640283,158.59609 35.5539239,159.895222 33.7448299,167",
    id: "Fill-3",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.126544,65 L269.873799,65 C269.623601,65 269.385149,64.8916124 269.219819,64.7029705 C269.053608,64.5140325 268.976375,64.2626088 269.006328,64.0123696 C269.681452,58.4437332 274.38764,54.2444531 279.95249,54.2444531 C281.309491,54.2444531 282.660325,54.5000228 283.922767,54.9904324 C284.693036,46.0588182 292.18811,39 301.211976,39 C310.785866,39 318.574599,46.8548453 318.574599,56.5093398 C318.574599,56.7036084 318.561972,56.8946193 318.549638,57.0856303 L318.492081,58.2305116 L316.746862,58.147296 L316.788268,57.2668687 C316.792966,57.1664768 316.799427,57.066085 316.806475,56.9656932 C316.816753,56.8143651 316.827618,56.663037 316.827618,56.5093398 C316.827618,47.826188 309.822369,40.7620393 301.211976,40.7620393 C292.697316,40.7620393 285.696178,47.7500797 285.606024,56.3393549 C285.6025,56.6473416 285.4404,56.9313408 285.177575,57.0879995 C284.915337,57.2449542 284.590256,57.2526539 284.321263,57.1075448 C282.982763,56.3870336 281.472472,56.0061962 279.95249,56.0061962 C275.604566,56.0061962 271.879788,59.0523031 270.913941,63.2382569 L336.107839,63.2382569 C335.122317,58.3359379 330.84634,54.7514465 325.789815,54.7514465 C325.471488,54.7514465 325.153749,54.7656613 324.847462,54.7932024 L323.977348,54.8716798 L323.821121,53.1167479 L324.691528,53.0379744 C325.049793,53.0059912 325.419511,52.9894073 325.789815,52.9894073 C332.070313,52.9894073 337.317422,57.7332908 337.994895,64.0239191 C338.021618,64.2729737 337.942624,64.5211399 337.776706,64.7077088 C337.610788,64.8939815 337.374392,65 337.126544,65",
    id: "Fill-5",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(19.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.99725,25.7209528 L1.06877542,25.7209528 C0.816063559,25.7209528 0.575512712,25.6140315 0.408224576,25.4279416 C0.24034322,25.2418517 0.162334746,24.9932449 0.192885593,24.7466831 C0.874792373,19.2533798 5.62767373,15.1109079 11.2487331,15.1109079 C12.6193686,15.1109079 13.9837754,15.3630202 15.2591992,15.8467955 C16.036911,7.03600899 23.6072924,0.0726831461 32.7221229,0.0726831461 C42.391911,0.0726831461 50.2591992,7.82126742 50.2591992,17.3451551 C50.2591992,17.5367955 50.2464449,17.7252225 50.2336907,17.9136494 L50.1755551,19.0430427 L48.4128008,18.9609528 L48.4546229,18.092436 C48.4593686,17.9934022 48.4661907,17.8943685 48.4730127,17.7953348 C48.4833941,17.6460539 48.4943686,17.496773 48.4943686,17.3451551 C48.4943686,8.77946966 41.4187331,1.81088539 32.7221229,1.81088539 C24.121911,1.81088539 17.0501314,8.70439101 16.959072,17.1774697 C16.9555127,17.4812899 16.7917839,17.7614472 16.5263178,17.9159865 C16.2617415,18.070818 15.9330975,18.0784135 15.6614025,17.9352674 C14.3094534,17.2245034 12.7836907,16.848818 11.2487331,16.848818 C6.85712288,16.848818 3.09491949,19.8537169 2.11966525,23.9827506 L67.9683093,23.9827506 C66.9728856,19.1470427 62.6539449,15.6110427 57.5466144,15.6110427 C57.225089,15.6110427 56.9041568,15.6250652 56.5947924,15.6522337 L55.7159364,15.7296494 L55.5584364,13.9984584 L56.4372924,13.9207506 C56.7991568,13.8892 57.172589,13.8728404 57.5466144,13.8728404 C63.8902161,13.8728404 69.1903432,18.5525483 69.8746229,24.7580764 C69.9013178,25.0034697 69.8215297,25.2485708 69.6539449,25.4323236 C69.4866568,25.6163685 69.247589,25.7209528 68.99725,25.7209528",
    id: "Fill-7",
    fill: "#000000",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M294.437788,161.139249 C289.54312,155.270712 279.912981,158.101816 279,165.723697 L280.76761,165.935716 C280.990544,164.080255 281.920881,162.422739 283.388354,161.268916 C287.449339,158.073368 293.577772,160.24446 294.572446,165.451188 L296.321803,165.116091 C296.151535,164.226692 295.847807,163.391196 295.439045,162.624276 C297.717458,161.495308 300.536298,162.409862 301.650967,164.753743 C301.655156,164.763925 302.080077,165.793771 302.233587,167 L304,166.774805 C303.245317,160.847574 298.032557,159.186165 294.437788,161.139249",
    id: "Fill-10",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2288685,167 C98.8931718,164.826141 97.1328692,163.126126 94.8482661,162.769671 C91.9590477,162.318391 89.2394826,164.180352 88.7663186,166.915171 L87,166.639832 C87.3071205,164.866699 88.3223325,163.313493 89.8600404,162.265836 C94.1437841,159.345365 100.226032,161.742294 101,166.753224 L99.2288685,167 Z",
    id: "Fill-12",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#000000",
    points: "82 168 84 168 84 129 82 129"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#000000",
    points: "84.4989422 146 83 145.222965 87.5007757 136 89 136.776744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4476465,148 L80.5788386,147.825319 C73.8697945,146.477903 69,140.612476 69,133.879787 C69,129.670174 71.8073073,119.755185 74.415221,112.323479 C78.216814,101.491779 81.2732888,96 83.499702,96 C85.7267112,96 88.783186,101.491779 92.5850771,112.323479 C95.1929908,119.755185 98,129.670174 98,133.879787 C98,140.261358 93.6291367,145.903825 87.37074,147.601481 L86.5165365,147.833804 L86.0435355,146.155752 L86.8986331,145.924014 C92.3910483,144.433811 96.2266187,139.480998 96.2266187,133.879787 C96.2266187,130.559966 94.0365673,121.866575 91.0194347,113.208881 C87.2017472,102.253413 84.3708941,97.9065711 83.4836074,97.7400826 C82.6288078,97.9065711 79.7985509,102.253998 75.9805653,113.209467 C72.9634327,121.866575 70.7733813,130.559966 70.7733813,133.879787 C70.7733813,139.789104 75.0464851,144.936787 80.934409,146.11947 L81.8032169,146.294151 L81.4476465,148 Z",
    id: "Fill-17",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#000000",
    points: "0 169 347 169 347 167 0 167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.507125,155.50003 L327.602193,155.50003 L327.602193,153.420974 L312.507125,153.420974 L312.507125,155.50003 Z M310.786387,160 L312.507125,160 L312.507125,157.285851 L327.602193,157.285851 L327.602193,160 L329.32322,160 L329.32322,157.285851 L331,157.285851 L331,155.50003 L329.32322,155.50003 L329.32322,153.420974 L331,153.420974 L331,151.635152 L329.32322,151.635152 L329.32322,150 L327.602193,150 L327.602193,151.635152 L312.507125,151.635152 L312.507125,150 L310.786387,150 L310.786387,151.635152 L309,151.635152 L309,153.420974 L310.786387,153.420974 L310.786387,155.50003 L309,155.50003 L309,157.285851 L310.786387,157.285851 L310.786387,160 Z",
    id: "Fill-19",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#000000",
    points: "337 161 309 161 309 162.747064 310.817968 162.747064 310.817968 168 312.569127 168 312.569127 162.747064 316.978221 162.747064 316.978221 168 318.729085 168 318.729085 162.747064 327.931352 162.747064 327.931352 168 329.68251 168 329.68251 162.747064 334.193437 162.747064 334.193437 168 335.944301 168 335.944301 162.747064 337 162.747064"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#000000",
    points: "263 167 265 167 265 128 263 128"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#000000",
    points: "265.498942 145 264 144.222965 268.501058 135 270 135.776744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.447646,147 L261.578839,146.825318 C254.869496,145.477895 250,139.612727 250,132.879708 C250,128.670364 252.807009,118.755026 255.414923,111.323278 C259.216814,100.49181 262.273289,95 264.499702,95 C266.726711,95 269.783186,100.49181 273.584779,111.323278 C276.192991,118.755026 279,128.670364 279,132.879708 C279,139.261314 274.629137,144.903813 268.37074,146.601771 L267.516536,146.834096 L267.043535,145.156035 L267.898633,144.924003 C273.391048,143.433791 277.226917,138.48095 277.226917,132.879708 C277.226917,129.559868 275.036567,120.866721 272.019435,112.208686 C268.201747,101.253155 265.370894,96.9062892 264.483607,96.7397998 C263.628808,96.9062892 260.798551,101.25374 256.980565,112.209271 C253.963433,120.866721 251.773381,129.559868 251.773381,132.879708 C251.773381,138.789058 256.046485,143.937063 261.934409,145.119752 L262.803217,145.294434 L262.447646,147 Z",
    id: "Fill-25",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(115.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: 404,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontSize: 35,
    fontWeight: "bold",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 34.31,
    y: 114
  }, "404")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#000000",
    strokeWidth: 2,
    x: 11,
    y: 12,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    stroke: "#000000",
    strokeWidth: 2,
    x: 11,
    y: 48,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    stroke: "#000000",
    strokeWidth: 2,
    x: 10,
    y: 136,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    stroke: "#000000",
    strokeWidth: 2,
    x: 10,
    y: 167,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#000000",
    strokeWidth: 2,
    x: 34,
    y: 12,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    stroke: "#000000",
    strokeWidth: 2,
    x: 34,
    y: 48,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    stroke: "#000000",
    strokeWidth: 2,
    x: 33,
    y: 136,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    stroke: "#000000",
    strokeWidth: 2,
    x: 33,
    y: 167,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    stroke: "#000000",
    strokeWidth: 2,
    x: 80,
    y: 12,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    stroke: "#000000",
    strokeWidth: 2,
    x: 80,
    y: 48,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    stroke: "#000000",
    strokeWidth: 2,
    x: 79,
    y: 136,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    stroke: "#000000",
    strokeWidth: 2,
    x: 79,
    y: 167,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    stroke: "#000000",
    strokeWidth: 2,
    x: 57,
    y: 12,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    stroke: "#000000",
    strokeWidth: 2,
    x: 57,
    y: 48,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    stroke: "#000000",
    strokeWidth: 2,
    x: 56,
    y: 136,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    stroke: "#000000",
    strokeWidth: 2,
    x: 56,
    y: 167,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-21",
    stroke: "#000000",
    strokeWidth: 2,
    x: 52,
    y: 204,
    width: 22,
    height: 33
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    stroke: "#000000",
    strokeWidth: 2,
    x: 103,
    y: 12,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    stroke: "#000000",
    strokeWidth: 2,
    x: 103,
    y: 48,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    stroke: "#000000",
    strokeWidth: 2,
    x: 102,
    y: 136,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    stroke: "#000000",
    strokeWidth: 2,
    x: 102,
    y: 167,
    width: 15,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#000000",
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 126,
    height: 238
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.40f00d75.svg";
export { ForwardRef as ReactComponent };